import React from "react";
import { Button } from "@mui/material";

interface IBtmReturnInspectionButtonProps {
    children: React.ReactNode;
    color: "success" | "warning" | "error";
    isSelected: boolean;
    isDisabled?: boolean;
    onClick: () => void;
}

export const BtmReturnInspectionButton = (props: IBtmReturnInspectionButtonProps) => {
    return <Button color={props.color} size={"medium"} onClick={() => props.onClick()} disabled={props.isDisabled}
            variant={props.isSelected ? "contained" : "outlined"}>
        {props.children}
    </Button>;
};
